import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { StatusDropdown } from '../../../../../modules/service-order/structure/structure';
import { PageElement } from '../../../../../modules/service-order/models/popup.model';
import { InventoryService } from '../../../services/inventory.service';
import { ItemsTabComponent } from '../../../modules/orders/components/parts-orders/parts-orders-popup/items-tab/items-tab.component';
import { CommonService } from 'projects/service/src/app/shared/services/common.service';
import { returnOrderStatuses } from '../../../models/orders.model';
import { ApiResponse, PopupTabs, UserRoles } from 'projects/service/src/app/shared/models/app.model';
import { DropDownListComponent } from '@syncfusion/ej2-angular-dropdowns';

@Component({
    selector: 'app-return-order-popup-details-tab',
    templateUrl: './return-order-popup-details-tab.component.html',
    styleUrls: ['./return-order-popup-details-tab.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReturnOrderPopupDetailsTabComponent implements OnInit, OnDestroy {

  @Input() tab: string = PopupTabs.details;
  @Input() id: string = null;
  @Input() showComments: boolean = false;
  @Input() details: any;
  @Input() shipmentMethods;
  @Input() categories;
  @Input() status;
  @Input() itemsTab: ItemsTabComponent;

  @ViewChild('categoryDDL') categoryDDL: DropDownListComponent;
  @ViewChild('shipmentMethod') shipmentMethod;
  @ViewChild('trackingId') trackingId;

  loadedData = null;
  statuses = returnOrderStatuses;
  statusDropdown: PageElement = StatusDropdown;

  showLoader: boolean = false;
  isExpanded: boolean = false;
  validationApplied: boolean = false;
  createdDate: Date = new Date();
  minEstimatedDate: Date = new Date();

  inventory = [];
  commentCount = 0;
  attachmentCount = 0;

  @ViewChild('commentsButton') commentsButton: ElementRef;
  @ViewChild('commentsPopup') commentsPopup: ElementRef;

  @Output() categoryChanged = new EventEmitter();
  @Output() onClose = new EventEmitter();
  @Output() onSave = new EventEmitter();
  @Output() onNeedRefresh = new EventEmitter();
  @Output() tabUpdated = new EventEmitter();

  USER;
  isManager: boolean = false;
  isCSA: boolean = false;
  constructor(
    private commonService: CommonService,
    private inventoryService: InventoryService
  ) {
    this.USER = this.commonService.USER;
    this.isManager = this.USER.role === UserRoles.manager;
    this.isCSA = this.USER.role === UserRoles.csa;
  }

  ngOnInit(): void { 
  }

  getData() {
    return this.details;
  }

  onCategorySelect(args: any) {
    args.cancel = true;
    
    const itemsGrid = (document.getElementById('return-order-items-grid') as any)?.ej2_instances[0];
    if ( itemsGrid.dataSource.filter( row => row.itemCode && !row.isDeleted).length ) {
      this.commonService.showConfirmation('Items data will be lost! Do you want to proceed?').then(res => {
        if( !res.isConfirmed) return;
        this.categoryDDL.value = args.itemData.value;
        this.categoryChanged.emit({ value: args.itemData.value, isInteracted: args.isInteracted });
      });
    } else {
      setTimeout(() => {
        this.categoryDDL.value = args.itemData.value;
        this.categoryChanged.emit({ value: args.itemData.value, isInteracted: args.isInteracted });
      }, 300);
    }
  }

  validate() {
    this.validationApplied = true;
    if (this.categoryDDL.value && this.shipmentMethod.value && this.trackingId.value) {
      return true;
    } else {
      return false;
    }
  }

  ngOnDestroy() {
    this.details = {};
  }
}
